module.exports = __webpack_public_path__ + "static/img/image060.6c96611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image060.png
// module id = NrYG
// module chunks = 1